import React from "react";
import classes from "./Actions.module.css";
import PlantLocations from "./PlantLocations";
import Search from "./Search";
import History from "./History";
import { Uppercase } from "../../../Utility";
import Modal from "../../Shared/PopupModal/PopupModal";
import Credits from "./Credits";

const Action = ({
  historyLocations = [],
  plantLocations = [],
  searchOptions = [],
  requestDataForLocation,
  allowedLocations,
  currentSearchedLocation,
  fetchLatestData,
  toggleLoader,
  referralCredits,
}) => {

  const closeModal = () => {
    document.getElementById("GetMoreCredits")?.click();
    toggleLoader(true);
    fetchLatestData();
  };

  return (
    <div className={classes.container}>
      {/* Section: Plant Locations */}
      {/* <PlantLocations
        plantLocations={plantLocations}
        requestDataForLocation={requestDataForLocation}
      /> */}

      {/* Section: Search */}
      <Search
        searchOptions={searchOptions}
        requestDataForLocation={requestDataForLocation}
        allowedLocations={allowedLocations}
        currentSearchedLocation={currentSearchedLocation}
      />

      {/* Section: Search Credits */}
      <div className={classes.creditsRow}>
        <span>
          <i className="fas fa-search" style={{ marginRight: "6px" }}></i>
          Search Credits
        </span>
        <span className={classes.creditsBadge}>{allowedLocations}</span>
        <div>
          <Modal
            content={<Credits closeModal={closeModal} referralCredits={referralCredits} />}
            buttonLabel="+ Get More"
            id="GetMoreCredits"
            buttonClass={classes.getMoreCreditsBtn}
            className={classes.getMoreCredits}
            activityName="Get More Credits"
            moduleName="Location Dashboard"
            screenName="Search Credits"
            title="Get More Credits"
            onClose={closeModal}
            showLogo={true}
          />
        </div>
      </div>

      {/* Section: Current Searched Location */}
      {currentSearchedLocation && (
        <div className={classes.currentLocationRow}>
          <i className="fas fa-search-location"></i>
          <span>{Uppercase(currentSearchedLocation)}</span>
        </div>
      )}

      {/* Section: History */}
      <History
        historyLocations={historyLocations}
        requestDataForLocation={requestDataForLocation}
      />
    </div>
  );
};

export default Action;